module.exports = __webpack_public_path__ + "static/media/veneto-village-01.5bd98273.jpg";